/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import moment from 'moment';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { isEmpty, cloneDeep, uniqBy, uniqWith } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { MultiSelect } from 'react-multi-select-component';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';
import Loader from '../../Components/Utility/Loader/Loader';
import * as action from './store/ProductCP.action';
import { complitionPercentage } from '../../Components/helper';
import { toasterMsg } from '../../Components/Toaster/Toaster';
import './ProductCP.css';
import PCPFilters from './PCPFilters';
import TabMenu from './TabMenu';
import LoaderBar from '../../Components/LoaderBar/LoaderBar';
import { useCPDetailState } from './contextProvider/cpDetailProvider';
import DetailTable from './DetailTable';
import DetailTablePO from './DetailTablePO';
import ImportModal from '../Library/BomLibrary/ImportModal';

let breaks = [];
let timerId = 0;

function DetailProductCP() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { pcpId } = useParams();
  const { t } = useTranslation('common');

  const navRef = useRef(null);
  const btnRef = useRef(null);
  const vlinksRef = useRef(null);
  const hlinksRef = useRef(null);
  const unMountData = useRef(null);

  const {
    Users: { userGroupsCardList },
    ProductCPReducer: { supplierList, productCpTabs, productCpColumnTabs, individualDetail, fetchtabColumns, calculationData },
    UserDetails: { userInfo, isSupplierLoggedIn },
  } = useSelector((reducer) => reducer);

  const userRole = userInfo?.role;
  const searchParams = new URLSearchParams(location?.search);
  const locaStates = location?.state;
  const fromArch = searchParams.get('fromArchive');
  const isProductArchived = locaStates?.fromArchive || Boolean(fromArch);
  const {
    detailState,
    setDetailState,
    setColumnsFilterData,
    setSelectedDays,
    filterState,
    setFilterState,
    timeZone,
    handleIconClick,
    expandSearchRef,
    initialFilterSetting,
    keys,
    showSupplierRef,
    productAddEditAccess,
    getTabColumn,
    columnsFilterData,
    handlePinnedColumnsChange,
  } = useCPDetailState();

  const [bulkUpdate, setBulkUpdate] = useState(false);
  const [copyValue, setCopyValue] = useState(null);
  const dateForamte = 'DD-MMMM-YYYY';
  const [showRequiredOnly, setShowRequiredOnly] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadLoader, setUploadLoader] = useState(false);
  const uploadDocRef = useRef(null);

  const staticColumnOptions = useMemo(() => {
    const defaults = [
      { label: 'Colourway', value: 'colorway' },
      { label: 'Factory', value: 'factory' },
      { label: 'Supplier', value: 'supplier' },
    ];
    if (individualDetail?.basedOnPO === true) {
      defaults.push(
        { label: t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.SKU_NUMBER'), value: 'skuNumber' },
        { label: t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.TRANSPORT'), value: 'transport' },
        { label: t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.SIZE'), value: 'size' },
        { label: t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.LOCATION'), value: 'location' },
        { label: t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.POQUANTITY'), value: 'quantity' },
        { label: t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.POAPPROVEDBYDATE'), value: 'approvedByDate' },
        { label: t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.EXFACTORYDATE'), value: 'exFactoryDate' },
        { label: t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.SHIPMENTDATE'), value: 'shipmentDate' },
      );
    }
    return defaults;
  }, [individualDetail?.basedOnPO, t]);

  useEffect(() => {
    if (fetchtabColumns?.length > 0) {
      const newColumnFilterData = fetchtabColumns.map((col) => ({
        label: col.name,
        value: col._id,
      }));
      const allColumnFilterData = [...staticColumnOptions, ...newColumnFilterData];
      setDetailState((prev) => ({
        ...prev,
        columnsTab: fetchtabColumns,
        pinnedColum: fetchtabColumns.filter((e) => e.isPinned).map((re) => re._id),
        columnFilterData: allColumnFilterData,
      }));
    }
  }, [fetchtabColumns, pcpId, staticColumnOptions]);

  useEffect(() => {
    return () => {
      dispatch(action.clearReducer());
      dispatch(action.clearReducerTab());
    };
  }, [dispatch]);

  useEffect(() => {
    if (fetchtabColumns?.length > 0 && detailState?.selectedColumnShow?.length > 0) {
      const storageKey = `pinnedColumns_${pcpId}`;
      const savedPinnedIds = JSON.parse(localStorage.getItem(storageKey)) || [];
      setDetailState((prev) => ({
        ...prev,
        selectedPinnedColumns: savedPinnedIds,
      }));
    }
  }, [fetchtabColumns, pcpId, detailState?.selectedColumnShow]);

  useEffect(() => {
    if (calculationData) {
      setDetailState((prev) => ({
        ...prev,
        finalPercentageCalculation: calculationData?.finalPercentageCalculation,
        finalCalculaions: calculationData?.finalCalculaions,
      }));
    }
  }, [calculationData]);

  useEffect(() => {
    if (userGroupsCardList || supplierList) {
      const options = [
        {
          name: 'Assignee',
          option: [...supplierList, ...userGroupsCardList],
          placeholder: t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.SELECT_ASSIGNEE'),
          noOption: 'No Assignee available',
          value: null,
        },
        {
          name: 'Completion',
          option: [...complitionPercentage],
          placeholder: t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.SELECT_COMPLETEION'),
          noOption: 'No Completion available',
          value: null,
        },
      ];
      setDetailState((previousDetails) => ({
        ...previousDetails,
        filterOptions: [...options],
      }));
    }
  }, [userGroupsCardList, supplierList]);

  const handleSearch = (e) => {
    const targetValue = e.target.value;

    setDetailState((searchState) => ({
      ...searchState,
      searchText: targetValue,
    }));
  };

  const submitSearch = async (e) => {
    if (e.keyCode === 13) {
      setDetailState((prevData) => ({
        ...prevData,
        searchLoaded: true,
      }));
    }
  };

  const redirectToListingPage = async () => {
    setDetailState({
      searchText: '',
      searchLoaded: false,
      showMobileSearch: false,
      loading: false,
      tableLoading: false,
      hasMore: false,
      pageIndex: 1,
      filterData: localStorage.getItem(`pcpFilters_${pcpId}`) ? JSON.parse(localStorage.getItem(`pcpFilters_${pcpId}`)) : initialFilterSetting,
      filterOptions: [],
      percentageColumns: [],
      tabId: null,
      tabChanged: false,
      expandAllColumns: false,
      selectAllColumns: false,
      selectedColumns: [],
      selectedColumnShow: [],
      isAssigneChecked: false,
      storedChangedData: [],
      columnsTab: [],
      tableColumData: [],
      tableProductDetail: [],
      pinnedColum: [],
      tabs: [],
      finalPercentageCalculation: [],
      finalCalculaions: [],
    });
    dispatch(action.clearReducer());
    dispatch(action.clearReducerTab());
    individualDetail?.isArchived ? history.push('/product-cp?fromArchive=true') : history.push('/product-cp');
  };

  const handleNextPageInScroll = async () => {
    if (detailState?.tableLoading || detailState?.loading || !detailState?.hasMore) {
      return;
    }
    const appliedFilterColumn = columnsFilterData?.find((item) => item.filterApplied);
    if (!appliedFilterColumn) {
      setDetailState((prevState) => ({
        ...prevState,
        tableLoading: true,
        id: pcpId,
      }));
      let params = {
        pageIndex: detailState.pageIndex + 1,
        pageSize: detailState.pageSize,
        searchText: detailState?.searchText,
        productCPId: pcpId,
        tabId: detailState.tabId || productCpTabs?.[0]?._id,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        totalWithCombinations: productCpColumnTabs?.totalWithCombinations,
        columnDetails: productCpColumnTabs?.columns
          ?.filter((colEle) => colEle.count || colEle?.onTimeCount || colEle?.delayedCount)
          .map((e) => ({
            colId: e?._id,
            count: e?.count,
            onTimeCount: e?.onTimeCount,
            delayedCount: e?.delayedCount,
          })),
      };
      if (detailState?.filterData && keys.some((key) => Array.isArray(detailState?.filterData?.[key]) && detailState?.filterData?.[key]?.length > 0)) {
        params = {
          ...params,
          ...Object.keys(detailState?.filterData || {}).reduce((acc, key) => {
            if (key !== 'selectedColumnShow' && Array.isArray(detailState.filterData[key]) && detailState.filterData[key].length > 0) {
              acc[key] = detailState.filterData[key];
            }
            return acc;
          }, {}),
        };
      }
      if (detailState?.sortData && detailState?.sortData?.sortBy && detailState?.sortData?.sortOrder) {
        params = {
          ...params,
          sortData: detailState?.sortData,
        };
      }
      if (productCpColumnTabs?.allProductIds?.length > 0) {
        params.allProductIds = productCpColumnTabs?.allProductIds;
      }
      if (productCpColumnTabs?.filteredProductIds?.length > 0) {
        params.filteredProductIds = productCpColumnTabs?.filteredProductIds;
      }
      const priorityColumns = ['colorway', 'supplier', 'factory'];
      const filterData = detailState?.selectedPinnedColumns?.filter((colId) => !priorityColumns.includes(colId));
      if (filterData?.length > 0) {
        params.allPin = filterData;
      }
      try {
        await Promise.all([dispatch(action.fetchTabColumnDataforPCP(params))]);
      } catch (error) {
        console.error('Error in handleNextPageInScroll:', error);
      } finally {
        setDetailState((prevState) => ({
          ...prevState,
          tableLoading: false,
          pageIndex: prevState.pageIndex + 1,
        }));
      }
    }
  };

  function findDependentColumns(queries, depObj, visited = new Set()) {
    const currentId = queries?._id;
    if (visited.has(currentId)) return;
    visited.add(currentId);
    const depArray = detailState?.columnsTab?.filter((e) => e.dependentColumnId === currentId);
    if (depArray?.length > 0) {
      depArray.forEach((depColumn) => {
        if (!depColumn?.dependentColumnId) return;

        depObj.push(depColumn);
        findDependentColumns(depColumn, depObj, visited);
      });
    }
  }

  function findDurationColumns(queries, depObj) {
    const depArray = detailState?.columnsTab?.filter((e) => e.durationlinkedColumnValue?._id === queries._id);
    if (depArray?.length > 0) {
      depArray.forEach((depColumn) => {
        if (depColumn) {
          if (!depColumn?.durationlinkedColumnValue) {
            return queries;
          }
          depObj.push(depColumn);
          return findDurationColumns(depColumn, depObj);
        }
      });
    } else {
      return queries;
    }
  }

  const matchesExpandEle = (expandEle, item) => {
    return (
      (!expandEle?.supplierId || item?.supplierId === expandEle?.supplierId) &&
      (!expandEle?.factoryId || item.factoryId === expandEle?.factoryId) &&
      (!expandEle?.colourId || item.colourId === expandEle?.colourId)
    );
  };

  const matchesPOExpandedRow = (item, expandEle) => {
    if (item?.rowKey && expandEle?.rowKey) {
      return item.rowKey === expandEle.rowKey;
    }
    return (
      item?.poId?.toString() === expandEle?.poId?.toString() &&
      item?.poOrderDetailIndex === expandEle?.poOrderDetailIndex &&
      item?.productId?.toString() === expandEle?.productId?.toString() &&
      (!item?.supplierId || !expandEle?.supplierId || item?.supplierId?.toString() === expandEle?.supplierId?.toString()) &&
      (!item?.factoryId || !expandEle?.factoryId || item?.factoryId?.toString() === expandEle?.factoryId?.toString()) &&
      (!item?.colourId || !expandEle?.colourId || item?.colourId?.toString() === expandEle?.colourId?.toString()) &&
      (!item?.skuNumber || !expandEle?.skuNumber || item?.skuNumber === expandEle?.skuNumber) &&
      (!item?.transport || !expandEle?.transport || item?.transport === expandEle?.transport)
    );
  };

  const changeManualInputs = useCallback(
    async (value, col, devEle, expandEle, fromChild) => {
      let dataArray = cloneDeep(detailState?.tableColumData || []);
      const isPOBased = individualDetail?.basedOnPO === true;

      const switchKey = typeof col?.manualType === 'object' ? col?.manualType?.key : col?.manualType;
      // True only when the user explicitly clears a date picker (value === null).
      // Parent-clear must NOT propagate to child rows; parent-set must still propagate.
      const isClearOperation = switchKey === 'Date_picker' && value === null;

      const getNewValue = (oldValue) => {
        switch (switchKey) {
          case 'Checkbox':
            return { ...oldValue, ...value };
          case 'Dropdown':
            return value?._id;
          case 'Status':
          case 'Date_picker':
          default:
            return value;
        }
      };

      let filteredDataBasedOnParent = [];
      const changedItems = [];
      let rowKeysToUpdate = [];
      if (isPOBased) {
        if (fromChild && expandEle) {
          const existingChildRow = dataArray.find(
            (item) => item.columnId === col?._id && item.rowKey !== devEle?.rowKey && matchesPOExpandedRow(item, expandEle),
          );
          if (!existingChildRow) {
            const seedRow = dataArray.find((item) => matchesPOExpandedRow(item, expandEle));
            if (seedRow) {
              const { _id: _omitted, ...seedWithoutId } = seedRow;
              dataArray.push({
                ...seedWithoutId,
                rowKey: expandEle?.rowKey ?? seedWithoutId.rowKey,
                columnId: col?._id,
                columnValue: null,
                estimatedDate: null,
                tabId: col?.tabId,
                type: col?.type || 'Date_picker',
                manualTypeKey: col?.manualType?.key || 'Date_picker',
              });
            }
          }
          filteredDataBasedOnParent = dataArray.filter(
            (item) => item.columnId === col?._id && item.rowKey !== devEle?.rowKey && matchesPOExpandedRow(item, expandEle),
          );
        } else {
          rowKeysToUpdate = isClearOperation
            ? [
                devEle?.rowKey,
                // Also clear children whose value was propagated from this parent (fromParent=true).
                // Children with independently entered data (fromParent !== true) are left untouched.
                ...(devEle?.expandData || [])
                  .filter((child) => {
                    const childData = dataArray.find((item) => item.columnId === col?._id && item.rowKey === child?.rowKey);
                    return childData?.fromParent === true;
                  })
                  .map((c) => c?.rowKey),
              ].filter(Boolean)
            : [devEle?.rowKey, ...(devEle?.expandData || []).map((c) => c?.rowKey)].filter(Boolean);

          rowKeysToUpdate.forEach((rowKey) => {
            const existingRow = dataArray.find((item) => item.columnId === col?._id && item.rowKey === rowKey);
            if (!existingRow) {
              const parentRow = dataArray.find((item) => item.rowKey === rowKey);
              if (parentRow) {
                const parentColumnValue = dataArray.find((item) => item.columnId === col?._id && item.rowKey === devEle?.rowKey);
                const { _id: _omitted, ...parentRowWithoutId } = parentRow;
                const newChildRow = {
                  ...parentRowWithoutId,
                  columnId: col?._id,
                  columnValue: parentColumnValue?.columnValue || null,
                  estimatedDate: parentColumnValue?.estimatedDate || null,
                  tabId: col.tabId,
                  type: col.type || 'Date_picker',
                  manualTypeKey: col.manualType?.key || 'Date_picker',
                };
                dataArray.push(newChildRow);
              }
            }
          });

          filteredDataBasedOnParent = dataArray.filter((item) => item.columnId === col?._id && rowKeysToUpdate.includes(item.rowKey));
        }
      } else {
        filteredDataBasedOnParent = dataArray.filter(
          (item) =>
            item.columnId === col?._id &&
            item.productId === devEle?._id &&
            (isClearOperation
              ? // On clear: parent row + children whose value was propagated from parent (fromParent=true).
                // Children with independently entered data (fromParent !== true) are left untouched.
                expandEle
                ? matchesExpandEle(expandEle, item)
                : (!item?.colourId && !item?.supplierId && !item?.factoryId) || item.fromParent === true
              : // On set: propagate to all child rows too (original behaviour)
                !expandEle || matchesExpandEle(expandEle, item)),
        );
      }

      if (filteredDataBasedOnParent.length > 0) {
        filteredDataBasedOnParent.forEach((item) => {
          const updatedItem = {
            ...item,
            columnValue: getNewValue(item.columnValue),
            fromParent: !fromChild,
          };
          changedItems.push(updatedItem);
        });
      }

      const mergedDataArray = isPOBased
        ? uniqWith([...changedItems, ...dataArray], (a, b) => a?.rowKey === b?.rowKey && a?.columnId === b?.columnId)
        : uniqWith(
            [...changedItems, ...dataArray],
            (a, b) =>
              a?.productId === b?.productId &&
              a?.colourId === b?.colourId &&
              a?.supplierId === b?.supplierId &&
              a?.factoryId === b?.factoryId &&
              a?.columnId === b?.columnId,
          );

      dataArray = mergedDataArray.map((item) => ({ ...item }));

      if (switchKey === 'Date_picker') {
        const dependentArray = [];
        const durationArray = [];

        findDependentColumns(col, dependentArray);
        findDurationColumns(col, durationArray);

        const uniqueDependentArray = uniqBy(dependentArray, '_id');
        const uniqueDurationArray = uniqBy(durationArray, '_id');

        if (isPOBased) {
          const shouldUpdateRow = (dataItem) => {
            if (fromChild && expandEle) {
              return matchesPOExpandedRow(dataItem, expandEle);
            }
            return rowKeysToUpdate.includes(dataItem?.rowKey);
          };
          const rowsToCheckForDependencies = fromChild && expandEle ? [] : rowKeysToUpdate;
          if (rowsToCheckForDependencies.length > 0) {
            uniqueDependentArray.forEach((depCol) => {
              rowsToCheckForDependencies.forEach((rowKey) => {
                const existingRow = dataArray.find((item) => item.columnId === depCol._id && item.rowKey === rowKey);
                if (!existingRow) {
                  const parentRow = dataArray.find((item) => item.rowKey === rowKey && item.columnId === col?._id);
                  if (parentRow) {
                    const { _id: _omitted, ...parentRowWithoutId } = parentRow;
                    const newDependentRow = {
                      ...parentRowWithoutId,
                      columnId: depCol._id,
                      columnValue: null,
                      estimatedDate: null,
                      tabId: depCol.tabId,
                      type: depCol.type || 'Date_picker',
                      manualTypeKey: depCol.manualType?.key || 'Date_picker',
                    };
                    dataArray.push(newDependentRow);
                  }
                }
              });
            });
          }

          uniqueDependentArray.forEach((depCol) => {
            dataArray.forEach((dataItem) => {
              if (depCol._id === dataItem?.columnId && shouldUpdateRow(dataItem)) {
                let dateVal = null;
                let finalVal = changedItems.find((e) => depCol.dependentColumnId === e?.columnId && shouldUpdateRow(e));
                if (!finalVal) {
                  finalVal = dataArray.find((e) => depCol.dependentColumnId === e?.columnId && shouldUpdateRow(e));
                }

                if (finalVal?.columnValue) {
                  try {
                    dateVal = moment(finalVal.columnValue).format(dateForamte);
                  } catch (error) {
                    console.error('Error formatting source column date:', error, 'value:', finalVal.columnValue);
                    dateVal = finalVal.columnValue;
                  }
                } else if (finalVal?.estimatedDate) {
                  try {
                    dateVal = moment(finalVal.estimatedDate).format(dateForamte);
                  } catch (error) {
                    console.error('Error formatting source estimated date:', error, 'value:', finalVal.estimatedDate);
                    dateVal = finalVal.estimatedDate;
                  }
                } else {
                  dateVal = null;
                }

                const { futureDependent, durationValue, durationUnit } = depCol.dependentObj;

                if (durationValue && durationUnit) {
                  if (dateVal) {
                    const operator = futureDependent ? 'add' : 'subtract';
                    const predictionDate = moment(dateVal)[operator](durationValue, durationUnit?.name);
                    dataItem.estimatedDate = moment(predictionDate).format(dateForamte);
                  } else {
                    dataItem.estimatedDate = null;
                  }
                }
              }
            });
          });
          const rowsToCheckForDuration = fromChild && expandEle ? [] : rowKeysToUpdate;
          if (rowsToCheckForDuration.length > 0) {
            uniqueDurationArray.forEach((durationCol) => {
              rowsToCheckForDuration.forEach((rowKey) => {
                const existingRow = dataArray.find((item) => item.columnId === durationCol._id && item.rowKey === rowKey);
                if (!existingRow) {
                  const parentRow = dataArray.find((item) => item.rowKey === rowKey && item.columnId === col?._id);
                  if (parentRow) {
                    const { _id: _omitted, ...parentRowWithoutId } = parentRow;
                    const newDurationRow = {
                      ...parentRowWithoutId,
                      columnId: durationCol._id,
                      columnValue: null,
                      estimatedDate: null,
                      tabId: durationCol.tabId,
                      type: durationCol.type || 'Date_picker',
                      manualTypeKey: durationCol.manualType?.key || 'Date_picker',
                    };
                    dataArray.push(newDurationRow);
                  }
                }
              });
            });
          }

          uniqueDurationArray.forEach((durationCol) => {
            dataArray.forEach((dataItem) => {
              if (durationCol?._id === dataItem?.columnId && shouldUpdateRow(dataItem)) {
                try {
                  if (Array.isArray(dataItem.columnValue)) {
                    dataItem.columnValue.forEach((v) => {
                      if (v?.columnValue) {
                        dataItem.durationDays = moment(value).format(dateForamte);
                      }
                    });
                  } else {
                    dataItem.durationDays = moment(value).format(dateForamte);
                  }
                } catch (error) {
                  console.error('Error setting duration days for PO based:', error, 'value:', value);
                  dataItem.durationDays = moment().format(dateForamte);
                }
              }
            });
          });
        } else {
          uniqueDependentArray.forEach((depCol) => {
            dataArray.forEach((dataItem) => {
              const matchesRowContext = (item) =>
                isClearOperation
                  ? // On clear: parent row + children whose value was propagated from parent (fromParent=true).
                    // Children with independently entered data (fromParent !== true) are left untouched.
                    expandEle
                    ? matchesExpandEle(expandEle, item)
                    : (!item?.colourId && !item?.supplierId && !item?.factoryId) || item.fromParent === true
                  : // On set: propagate dependency recalculation to all child rows too
                    !expandEle || matchesExpandEle(expandEle, item);

              if (depCol._id === dataItem?.columnId && dataItem?.productId === devEle?._id && matchesRowContext(dataItem)) {
                let dateVal = null;

                let finalVal = changedItems.find((e) => depCol.dependentColumnId === e?.columnId && e?.productId === devEle?._id && matchesRowContext(e));

                if (!finalVal) {
                  finalVal = dataArray.find((e) => depCol.dependentColumnId === e?.columnId && e?.productId === devEle?._id && matchesRowContext(e));
                }

                if (finalVal?.columnValue) {
                  try {
                    dateVal = moment(finalVal.columnValue).format(dateForamte);
                  } catch (error) {
                    console.error('Error formatting source column date (non-PO):', error, 'value:', finalVal.columnValue);
                    dateVal = finalVal.columnValue;
                  }
                } else if (finalVal?.estimatedDate) {
                  try {
                    dateVal = moment(finalVal.estimatedDate).format(dateForamte);
                  } catch (error) {
                    console.error('Error formatting source estimated date (non-PO):', error, 'value:', finalVal.estimatedDate);
                    dateVal = finalVal.estimatedDate;
                  }
                } else {
                  dateVal = null;
                }

                const { futureDependent, durationValue, durationUnit } = depCol.dependentObj;

                if (durationValue && durationUnit) {
                  if (dateVal) {
                    const operator = futureDependent ? 'add' : 'subtract';
                    const predictionDate = moment(dateVal)[operator](durationValue, durationUnit?.name);
                    dataItem.estimatedDate = moment(predictionDate).format(dateForamte);
                  } else {
                    dataItem.estimatedDate = null;
                  }
                }
              }
            });
          });

          uniqueDurationArray.forEach((durationCol) => {
            dataArray.forEach((dataItem) => {
              if (durationCol?._id === dataItem?.columnId && devEle?._id === dataItem?.productId && (!expandEle || matchesExpandEle(expandEle, dataItem))) {
                try {
                  if (Array.isArray(dataItem.columnValue)) {
                    dataItem.columnValue.forEach((v) => {
                      if (v?.columnValue) {
                        dataItem.durationDays = moment(value).format(dateForamte);
                      }
                    });
                  } else {
                    dataItem.durationDays = moment(value).format(dateForamte);
                  }
                } catch (error) {
                  console.error('Error setting duration days for non-PO based:', error, 'value:', value);
                  dataItem.durationDays = moment().format(dateForamte);
                }
              }
            });
          });
        }
      }

      const scrollContainer = document.getElementById('CPTableContainer');
      const savedScrollLeft = scrollContainer?.scrollLeft ?? 0;

      setDetailState((prev) => {
        const updatedStoredChangedData = [...(prev.storedChangedData || [])];

        changedItems
          .filter((changedItem) => !changedItem?.isParentRow)
          .forEach((changedItem) => {
            const index = isPOBased
              ? updatedStoredChangedData.findIndex((i) => i.rowKey === changedItem.rowKey && i.columnId === changedItem.columnId)
              : updatedStoredChangedData.findIndex(
                  (i) =>
                    i.productId === changedItem.productId &&
                    i.columnId === changedItem.columnId &&
                    i.colourId === changedItem.colourId &&
                    i.factoryId === changedItem.factoryId &&
                    i.supplierId === changedItem.supplierId,
                );

            if (index > -1) updatedStoredChangedData[index] = changedItem;
            else updatedStoredChangedData.push(changedItem);
          });

        return {
          ...prev,
          tableColumData: dataArray,
          storedChangedData: updatedStoredChangedData,
          lastUpdate: Date.now(),
          savedScrollLeft,
        };
      });
    },
    [detailState, individualDetail],
  );

  const onSelectCheckBox = useMemo(() => {
    return (e, id) => {
      setDetailState((oldState) => {
        const { selectedColumns, tableProductDetail } = oldState;
        const products = tableProductDetail || [];
        const isPOBased = individualDetail?.basedOnPO === true;

        let updatedSelectedColumns;

        if (isPOBased) {
          const isParentRow = products.some((parent) => parent.rowKey === id);

          if (e.target.checked) {
            if (isParentRow) {
              const parent = products.find((p) => p.rowKey === id);
              const childRowKeys = parent?.expandData?.map((child) => child.rowKey) || [];
              updatedSelectedColumns = [...selectedColumns, id, ...childRowKeys];
            } else {
              updatedSelectedColumns = [...selectedColumns, id];
            }
          } else if (isParentRow) {
            const parent = products.find((p) => p.rowKey === id);
            const childRowKeys = parent?.expandData?.map((child) => child.rowKey) || [];
            updatedSelectedColumns = selectedColumns.filter((item) => item !== id && !childRowKeys.includes(item));
          } else {
            updatedSelectedColumns = selectedColumns.filter((item) => item !== id);
          }
        } else if (e.target.checked) {
          updatedSelectedColumns = [...selectedColumns, id];
        } else {
          updatedSelectedColumns = selectedColumns.filter((item) => item !== id);
        }

        const selectAllColumns = updatedSelectedColumns?.length === products?.length;

        return {
          ...oldState,
          selectedColumns: updatedSelectedColumns,
          selectAllColumns,
        };
      });
    };
  }, [individualDetail?.basedOnPO]);

  const handleSelectAllColumnOfTabs = useMemo(() => {
    return (e) => {
      setDetailState((oldState) => {
        const products = oldState?.tableProductDetail || [];
        const isPOBased = individualDetail?.basedOnPO === true;
        let selectedColumns = [];
        if (e?.target?.checked) {
          if (isPOBased) {
            const parentRowKeys = products?.filter((ele) => ele?.rowKey).map((ele) => ele.rowKey) || [];
            const childRowKeys = products?.flatMap((ele) => ele?.expandData?.map((child) => child.rowKey) || []) || [];
            selectedColumns = [...parentRowKeys, ...childRowKeys];
          } else {
            selectedColumns = products?.map((ele) => ele?._id);
          }
        }
        return {
          ...oldState,
          selectAllColumns: e?.target?.checked,
          selectedColumns,
        };
      });
    };
  }, [individualDetail?.basedOnPO]);

  const expandAllProductInfo = useMemo(() => {
    return (expandAll) => {
      setDetailState((prevData) => {
        const updatedProducts = (prevData?.tableProductDetail || []).map((prodEle) => {
          if (prodEle?.expandData?.length > 0 && prodEle.isExpanded !== expandAll) {
            return {
              ...prodEle,
              isExpanded: expandAll,
            };
          }
          return prodEle;
        });

        if (prevData.expandAllColumns !== expandAll) {
          return {
            ...prevData,
            expandAllColumns: expandAll,
            tableProductDetail: updatedProducts,
          };
        }

        return prevData;
      });
    };
  }, []);

  const expandProductInfo = useMemo(() => {
    return async (i) => {
      setDetailState((prevState) => {
        const { tableProductDetail } = prevState;

        const updatedProducts = tableProductDetail.map((prod, index) => {
          if (i === index && prod?.expandData?.length > 0) {
            return {
              ...prod,
              isExpanded: !prod.isExpanded,
            };
          }
          return prod;
        });

        return {
          ...prevState,
          expandAllColumns: false,
          tableProductDetail: updatedProducts,
        };
      });
    };
  }, []);

  const saveDetailPCP = async () => {
    if (detailState?.storedChangedData?.length > 0) {
      const isPOBased = individualDetail?.basedOnPO === true;
      if (isPOBased) {
        const dataPayload = detailState.storedChangedData.map((item) => {
          let packType = null;

          if (item?.rowKey) {
            const matchingRow = detailState?.tableProductDetail?.find(
              (row) => row?.rowKey === item?.rowKey || row?.expandData?.some((expandRow) => expandRow?.rowKey === item?.rowKey),
            );

            if (matchingRow) {
              if (matchingRow?.rowKey === item?.rowKey) {
                packType = matchingRow?.packType;
              } else {
                const childRow = matchingRow?.expandData?.find((expandRow) => expandRow?.rowKey === item.rowKey);
                packType = childRow?.packType;
              }
            }
          }

          return {
            ...item,
            productCPId: item?.productCPId || pcpId,
            tabId: item?.tabId || detailState?.tabId,
            loggedInUserId: userInfo?.userId,
            type: item?.type || item?.manualType?.key || item?.manualTypeKey,
            manualTypeKey: item?.manualType?.key || item?.manualTypeKey,
            packType: packType ?? item?.packType,
          };
        });
        const poParams = { data: dataPayload, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone };
        await dispatch(action.insertManualDataPO(poParams, t));
      } else {
        const params = { data: detailState.storedChangedData, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone };
        await dispatch(action.insertManualData(params, t));
      }
      const activeFilters = Object.keys(detailState?.dependentFilter || {}).filter(
        (columnId) => detailState?.dependentFilter[columnId] === 'onTime' || detailState?.dependentFilter[columnId] === 'late',
      );
      const hasActiveFilter = activeFilters.length > 0;

      let getParams = {
        productCPId: pcpId,
        tabId: detailState?.tabId,
        pageSize: detailState.pageSize,
        searchText: detailState?.searchText,
        pageIndex: hasActiveFilter ? 1 : detailState?.pageIndex,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        recalculate: true,
      };
      const priorityColumns = ['colorway', 'supplier', 'factory'];
      const filterData = detailState?.selectedPinnedColumns?.filter((colId) => !priorityColumns.includes(colId));
      if (filterData?.length > 0) {
        getParams.allPin = filterData;
      }
      if (productCpColumnTabs?.allProductIds?.length > 0) {
        getParams.allProductIds = productCpColumnTabs?.allProductIds;
      }
      if (productCpColumnTabs?.filteredProductIds?.length > 0) {
        getParams.filteredProductIds = productCpColumnTabs?.filteredProductIds;
      }

      if (hasActiveFilter) {
        if (isPOBased) {
          const columnFilters = {};
          activeFilters.forEach((columnId) => {
            const filterValue = detailState?.dependentFilter[columnId];
            columnFilters[columnId] = {
              onTimeLateFilter: filterValue,
            };
          });
          getParams.columnFilters = columnFilters;
        } else {
          const columnId = activeFilters[0];
          const filterValue = detailState?.dependentFilter[columnId];
          getParams.columnId = columnId;
          getParams.onTimeLateFilter = filterValue;
        }
      }

      setDetailState((debouncestate) => ({
        ...debouncestate,
        pageIndex: hasActiveFilter ? 1 : detailState?.pageIndex,
        selectedColumns: [],
        storedChangedData: [],
      }));
      if (detailState?.filterData && keys.some((key) => Array.isArray(detailState?.filterData[key]) && detailState?.filterData[key].length > 0)) {
        getParams = {
          ...getParams,
          ...Object.keys(detailState?.filterData || {}).reduce((acc, key) => {
            if (key !== 'selectedColumnShow' && Array.isArray(detailState.filterData[key]) && detailState.filterData[key].length > 0) {
              acc[key] = detailState.filterData[key];
            }
            return acc;
          }, {}),
        };
        await Promise.all([dispatch(action.fetchTabColumnDataforPCP(getParams, true))]);
      } else {
        await Promise.all([dispatch(action.fetchTabColumnDataforPCP(getParams, true))]);
      }
    } else {
      toasterMsg('There is no data change please change the data to save.', 'danger');
    }

    unMountData.current = null;
  };

  const changeTabs = async (id) => {
    setColumnsFilterData((prev) => (prev?.length > 0 ? prev.map((item) => ({ ...item, filterApplied: false })) : []));
    setSelectedDays([]);
    setDetailState((oldState) => ({
      ...oldState,
      tabId: id,
      loading: true,
      tabChanged: true,
      columnsTab: [],
      tableColumData: [],
      tableProductDetail: [],
      pinnedColum: [],
      sortData: { sortAt: 'ProductInfo', sortBy: null, sortOrder: null },
    }));
    if (productCpColumnTabs?.productDetails?.length === 0) {
      setColumnsFilterData([]);
    }
    let params = {
      pageIndex: 1,
      pageSize: detailState?.pageSize,
      searchText: detailState?.searchText,
      productCPId: pcpId,
      tabId: id,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      recalculate: true,
      tabChanged: true,
      columnId: null,
    };
    if (productCpColumnTabs?.allProductIds?.length > 0) {
      params.allProductIds = productCpColumnTabs?.allProductIds;
    }
    if (productCpColumnTabs?.filteredProductIds?.length > 0) {
      params.filteredProductIds = productCpColumnTabs?.filteredProductIds;
    }
    if (detailState?.filterData && keys.some((key) => Array.isArray(detailState?.filterData[key]) && detailState?.filterData[key].length > 0)) {
      params = {
        ...params,
        ...Object.keys(detailState?.filterData || {}).reduce((acc, key) => {
          if (key !== 'selectedColumnShow' && Array.isArray(detailState.filterData[key]) && detailState.filterData[key].length > 0) {
            acc[key] = detailState.filterData[key];
          }
          return acc;
        }, {}),
      };
    }
    const priorityColumns = ['colorway', 'supplier', 'factory'];
    if (individualDetail?.basedOnPO === true) {
      priorityColumns.push('skuNumber', 'transport', 'size', 'location', 'quantity', 'approvedByDate', 'exFactoryDate', 'shipmentDate');
    }
    const filterData = detailState?.selectedPinnedColumns?.filter((colId) => !priorityColumns.includes(colId));
    const tabParms = {
      tabId: id,
      pcpId,
      allPin: filterData,
    };
    if (filterData?.length > 0) {
      params.allPin = filterData;
    }
    const clearedReducer = await Promise.all([
      dispatch(action.clearReducer()),
      dispatch(action.getTabColumns(tabParms)),
      dispatch(action.fetchTabColumnDataforPCP(params)),
    ]);
    if (clearedReducer) {
      setDetailState((oldState) => ({
        ...oldState,
        loading: false,
        pageIndex: 1,
        tabChanged: false,
        columnId: null,
      }));
    }
  };

  useEffect(() => {
    if (detailState?.tabs?.length > 0 && !detailState?.tabId && !detailState?.loading && !detailState?.isMainLoading) {
      const firstTabId = detailState.tabs[0]._id;
      if (firstTabId) {
        changeTabs(firstTabId);
      }
    }
  }, [detailState?.tabs, detailState?.tabId, detailState?.loading, detailState?.isMainLoading]);

  const updateNav = () => {
    timerId = setTimeout(() => {
      const nav = navRef.current;
      const btn = btnRef.current;
      const vlinks = vlinksRef.current;
      const hlinks = hlinksRef.current;
      if (nav && btn && vlinks && hlinks) {
        const availableSpace = btn.classList.contains('hidden') ? nav.clientWidth : nav.clientWidth - btn.clientWidth - 30;

        if (vlinks.clientWidth > availableSpace) {
          if (vlinks.lastChild) {
            breaks.push(vlinks.clientWidth);
            hlinks.prepend(vlinks.lastChild);
          }

          if (btn.classList.contains('hidden')) {
            btn.classList.remove('hidden');
          }
        } else {
          if (availableSpace > breaks[breaks?.length - 1] && !isEmpty(hlinks) && !isEmpty(vlinks) && hlinks.lastChild) {
            vlinks.append(hlinks.firstChild);
            breaks.pop();
          }
          if (breaks?.length < 1) {
            btn.classList.add('hidden');
            hlinks.classList.add('hidden');
          }
        }
        btn.setAttribute('count', breaks?.length);
        if (vlinks.clientWidth > availableSpace) {
          updateNav();
        }
      }
    }, 300);
  };

  useEffect(() => {
    const handleResize = () => {
      updateNav();
    };
    const handleWindowResize = () => {
      clearTimeout(timerId);
      timerId = setTimeout(handleResize, 300);
    };
    if (!detailState.loading) {
      updateNav();
      window.addEventListener('resize', handleWindowResize);
    }
    return () => {
      clearTimeout(timerId);
      window.removeEventListener('resize', handleWindowResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailState?.tabs?.length, detailState.loading]);

  useEffect(() => {
    return () => {
      breaks = [];
    };
  }, []);

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setDetailState((oldState) => ({
      ...oldState,
      isAssigneChecked: isChecked,
    }));
  };

  const handleShowRequiredChange = (event) => {
    const isChecked = event.target.checked;
    setShowRequiredOnly(isChecked);
  };

  const tableContainer = () => {
    if (isEmpty(detailState?.tabs) && !detailState?.isMainLoading && !detailState?.tableLoading) {
      return (
        <Container fluid className="py-4">
          <Row>
            <Col md="12">
              <p className="alert alert-info override-alert-info justify-content-center align-item-center d-flex">
                {t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.CRITICAL_PATH')}
              </p>
            </Col>
          </Row>
        </Container>
      );
    }
    return (
      <div className="bom-list py-3">
        <Container fluid className="p-0 mb-2">
          <TabMenu
            activeTheTab={changeTabs}
            masterActiveTab={detailState.tabId}
            loader={detailState.isMainLoading}
            MenuList={detailState?.tabs}
            bulkUpdate={bulkUpdate}
            tableLoading={detailState?.loading}
            handleCheckboxChange={handleCheckboxChange}
            isChecked={detailState?.isAssigneChecked}
            userRole={userRole}
          />
          {renderTableContent()}
        </Container>
      </div>
    );
  };

  function renderTableContent() {
    const showLoader = detailState?.columnFilterApplied && detailState?.LoaderPercentage < 100 && detailState?.LoaderPercentage > 0;

    if (showLoader) {
      return <LoaderBar percent={detailState?.LoaderPercentage} />;
    }

    if (individualDetail?.basedOnPO === true) {
      return (
        <DetailTablePO
          key={`table-po-${pcpId}`}
          handleNextPageInScroll={handleNextPageInScroll}
          expandAllProductInfo={expandAllProductInfo}
          onSelectCheckBox={onSelectCheckBox}
          expandProductInfo={expandProductInfo}
          handleSelectAllColumnOfTabs={handleSelectAllColumnOfTabs}
          changeManualInputs={changeManualInputs}
          bulkUpdate={bulkUpdate}
          copyValue={copyValue}
          setCopyValue={setCopyValue}
          pcpId={pcpId}
          showRequiredOnly={showRequiredOnly}
          selectedPinnedColumns={detailState?.selectedPinnedColumns}
        />
      );
    }

    return (
      <DetailTable
        handleNextPageInScroll={handleNextPageInScroll}
        expandAllProductInfo={expandAllProductInfo}
        onSelectCheckBox={onSelectCheckBox}
        expandProductInfo={expandProductInfo}
        handleSelectAllColumnOfTabs={handleSelectAllColumnOfTabs}
        changeManualInputs={changeManualInputs}
        bulkUpdate={bulkUpdate}
        copyValue={copyValue}
        setCopyValue={setCopyValue}
        pcpId={pcpId}
        showRequiredOnly={showRequiredOnly}
        selectedPinnedColumns={detailState?.selectedPinnedColumns}
      />
    );
  }

  const downloadOCPDetailsExcel = async () => {
    const isPOBased = individualDetail?.basedOnPO === true;

    const filterData = detailState?.filterData || {};
    const uiOnlyKeys = [
      'selectedColumnShow',
      'monthOptions',
      'yearOptions',
      'brandOptions',
      'category1Options',
      'category2Options',
      'category3Options',
      'category4Options',
      'productTypeOptions',
      'productStatusOptions',
      'seasonOptions',
      'supplierOptions',
      'createdByOption',
    ];
    const cleanedFilterData = Object.keys(filterData).reduce((acc, key) => {
      if (!uiOnlyKeys.includes(key) && Array.isArray(filterData[key]) && filterData[key].length > 0) {
        acc[key] = filterData[key];
      }
      return acc;
    }, {});

    const body = {
      timeZone,
      pcpId,
      pcpSlugLink: window.location.href,
      filterData: cleanedFilterData,
      searchText: detailState?.searchText,
    };

    if (isPOBased) {
      const allProductIds = productCpColumnTabs?.allProductIds || [];

      if (productCpColumnTabs?.filteredProductIds && productCpColumnTabs.filteredProductIds.length > 0) {
        body.filteredProductIds = productCpColumnTabs.filteredProductIds;
      }

      body.allProductIds = allProductIds;
    }

    await dispatch(action.downloadPCPExcel(body, t));
  };

  const handlePCPUpload = () => {
    setShowUploadModal(true);
  };

  const closeUploadModal = () => {
    setShowUploadModal(false);
  };

  const handleUploadConfirm = async () => {
    try {
      const uploadedFile = uploadDocRef.current?.selectedDocument?.();

      if (!uploadedFile?.document) {
        return;
      }

      const file = uploadedFile.document;

      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        toasterMsg(t('File size exceeds 10MB limit'), 'danger');
        return;
      }

      const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];

      if (!validTypes.includes(file.type)) {
        toasterMsg(t('Invalid file type. Please select .xlsx or .xls file'), 'danger');
        return;
      }

      setUploadLoader(true);
      toasterMsg(t('Uploading PCP file...'), 'info');

      const result = await dispatch(action.uploadPCPFileToS3(file, individualDetail?._id, individualDetail?.basedOnPO));

      if (result?.success) {
        toasterMsg(t('PCP file uploaded successfully'), 'success');
        setShowUploadModal(false);
      } else {
        toasterMsg(result?.message || t('Upload failed'), 'danger');
      }
    } catch (error) {
      console.error('PCP upload error:', error);
      toasterMsg(t('Failed to upload PCP file. Please try again.'), 'danger');
    } finally {
      setUploadLoader(false);
    }
  };

  const applyFilter = (filterObject) => {
    setDetailState((prevData) => ({
      ...prevData,
      filterData: filterObject,
      pageIndex: 1,
      loading: true,
    }));
    getTabColumn(filterObject);
  };

  const bulkUpdateClicked = async () => {
    if (bulkUpdate && detailState?.selectedColumns?.length > 0) {
      const isPOBased = individualDetail?.basedOnPO === true;
      let dataArray;

      if (isPOBased) {
        const selectedRowKeys = new Set(detailState?.selectedColumns?.filter(Boolean) || []);
        dataArray = [];
        for (const product of detailState?.tableProductDetail || []) {
          const allRows = [product, ...(product?.expandData || [])];
          for (const row of allRows) {
            if (!selectedRowKeys.has(row?.rowKey)) continue;
            dataArray.push({
              productId: row?.productId || row?._id,
              rowKey: row?.rowKey,
              poId: product?.poId || row?.poId,
              poOrderDetailIndex: row?.poOrderDetailIndex,
              colourId: row?.colourId || null,
              supplierId: row?.supplierId || null,
              factoryId: row?.factoryId || null,
              sizeId: row?.sizeId || null,
              skuNumber: row?.skuNumber || null,
              location: row?.location || null,
              transport: row?.transport || null,
              packType: row?.packType || null,
              productCPId: copyValue?.productCPId,
              tabId: copyValue?.tabId,
              columnId: copyValue?.columnId,
              type: copyValue?.type,
            });
          }
        }
      } else {
        const selectedSet = new Set(detailState?.selectedColumns || []);
        dataArray = [];
        for (const product of detailState?.tableProductDetail || []) {
          if (!selectedSet.has(product._id)) continue;
          if (product?.expandData?.length > 0) {
            for (const expandRow of product.expandData) {
              dataArray.push({
                productId: product._id,
                colourId: expandRow.colourId || null,
                supplierId: expandRow.supplierId || null,
                factoryId: expandRow.factoryId || null,
                productCPId: copyValue?.productCPId,
                tabId: copyValue?.tabId,
                columnId: copyValue?.columnId,
                type: copyValue?.type,
              });
            }
          } else {
            dataArray.push({
              productId: product._id,
              colourId: product.colourId || null,
              supplierId: product.supplierId || null,
              factoryId: product.factoryId || null,
              productCPId: copyValue?.productCPId,
              tabId: copyValue?.tabId,
              columnId: copyValue?.columnId,
              type: copyValue?.type,
            });
          }
        }
      }

      if (copyValue) {
        const params = {
          copyValue,
          productCPId: pcpId,
          tabId: detailState?.tabId,
          selectedProducts: dataArray,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
        setDetailState((oldState) => ({
          ...oldState,
          loading: true,
          pageIndex: 1,
        }));
        const res = await dispatch(action.bulkUpdatePCP(params, t));
        if (res) {
          let getApiParams = {
            pageIndex: 1,
            pageSize: detailState?.pageSize,
            searchText: detailState?.searchText,
            productCPId: pcpId,
            tabId: detailState?.tabId,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            recalculate: true,
          };
          const priorityColumns = ['colorway', 'supplier', 'factory'];
          const filterPinData = detailState?.selectedPinnedColumns?.filter((colId) => !priorityColumns.includes(colId));
          if (filterPinData?.length > 0) {
            getApiParams.allPin = filterPinData;
          }
          if (detailState?.filterData && keys.some((key) => Array.isArray(detailState?.filterData?.[key]) && detailState?.filterData?.[key]?.length > 0)) {
            getApiParams = {
              ...getApiParams,
              ...Object.keys(detailState?.filterData || {}).reduce((acc, key) => {
                if (key !== 'selectedColumnShow' && Array.isArray(detailState.filterData[key]) && detailState.filterData[key].length > 0) {
                  acc[key] = detailState.filterData[key];
                }
                return acc;
              }, {}),
            };
          }
          if (productCpColumnTabs?.allProductIds?.length > 0) {
            getApiParams.allProductIds = productCpColumnTabs?.allProductIds;
            getApiParams.tabChanged = true;
          }
          if (productCpColumnTabs?.filteredProductIds?.length > 0) {
            getApiParams.filteredProductIds = productCpColumnTabs?.filteredProductIds;
          }
          if (productCpColumnTabs?.allProductIds?.length > 0) {
            setDetailState((oldData) => ({
              ...oldData,
              loading: true,
              pageIndex: 1,
              tableColumData: [],
              tableProductDetail: [],
              hasMore: true,
              LoaderPercentage: 0,
              selectedColumns: [],
              selectAllColumns: false,
            }));
            await dispatch(action.clearReducerTableDetails());
            await dispatch(action.fetchTabColumnDataforPCP(getApiParams));
          } else {
            setDetailState((oldState) => ({
              ...oldState,
              loading: true,
              pageIndex: 1,
              hasMore: false,
              tableColumData: [],
              tableProductDetail: [],
              selectedColumns: [],
              selectAllColumns: false,
              columnFetchParams: null,
              columnFilterApplied: false,
            }));
            await dispatch(action.clearReducer());
            await Promise.all([dispatch(action.getIndividualDetails(pcpId)), dispatch(action.fetchTabColumnDataforPCP(getApiParams))]);
          }
          setDetailState((oldState) => ({
            ...oldState,
            loading: false,
          }));
          setCopyValue(null);
        } else {
          setDetailState((oldState) => ({ ...oldState, loading: false }));
        }
      } else {
        toasterMsg(t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.NO_DATA_TO_COPY'), 'danger');
      }
    }
    setCopyValue(null);
    setBulkUpdate(!bulkUpdate);
  };

  const handleFilterSelect = (selected) => {
    const selectedIds = selected.map((opt) => opt.value);
    const storageKey = `selectedColumns_${pcpId}`;
    localStorage.setItem(storageKey, JSON.stringify(selectedIds));
    const pinnedStorageKey = `pinnedColumns_${pcpId}`;
    const currentPinnedIds = JSON.parse(localStorage.getItem(pinnedStorageKey)) || [];
    const updatedPinnedIds = currentPinnedIds.filter((id) => selectedIds.includes(id));
    localStorage.setItem(pinnedStorageKey, JSON.stringify(updatedPinnedIds));
    setDetailState((prev) => ({
      ...prev,
      selectedPinnedColumns: updatedPinnedIds,
    }));
    setDetailState((prev) => ({
      ...prev,
      selectedColumnShow: selectedIds,
    }));
  };

  const handlePinnedColumnSelect = (selected) => {
    if (selected.length > 5) {
      toasterMsg(t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.MAX_5_PINNED_COLUMNS'), 'danger');
      return;
    }
    const selectedIds = selected.map((opt) => opt.value);
    setDetailState((prev) => ({
      ...prev,
      selectedPinnedColumns: selectedIds,
    }));
    const storageKey = `pinnedColumns_${pcpId}`;
    localStorage.setItem(storageKey, JSON.stringify(selectedIds));
    handlePinnedColumnsChange();
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title  w-xs-300px">
            {t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.PRODUCT_CRITICAL_PATHS')} <span title={individualDetail?.name}>{individualDetail?.name}</span>
          </h4>
        </div>
        <div className="ml-auto d-flex justify-content-center align-items-center">
          {(userRole === 'User' || userRole === 'Supplier') && (
            <div className="d-flex justify-content-center align-items-center">
              <label className="mr-16 text-bold mb-0">Show Required </label>
              <div className="common-checkbox size-sm bold mr-16">
                <input type="checkbox" id="showRequired" checked={showRequiredOnly} onChange={handleShowRequiredChange} />
                <label htmlFor="showRequired" className="chklabel">
                  <span className="sr-only" />
                </label>
              </div>
            </div>
          )}
          {userRole === 'User' && (
            <div className="d-flex justify-content-center align-items-center">
              <label className="mr-16 text-bold mb-0">Show only assigned to me</label>
              <div className="common-checkbox size-sm bold mr-16">
                <input type="checkbox" id="showOnlyAssigned" checked={detailState?.isAssigneChecked} onChange={handleCheckboxChange} />
                <label htmlFor="showOnlyAssigned" className="chklabel">
                  <span className="sr-only" />
                </label>
              </div>
            </div>
          )}
          {detailState?.selectedColumns?.length > 0 && (
            <div className="d-flex justify-content-center align-items-center mr-16">
              <span className="text-bold mb-0">
                {t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.SELECTED_ROWS_COUNT', {
                  count: detailState?.selectedColumns?.length || 0,
                }) || `${detailState?.selectedColumns?.length || 0} row(s) selected`}
              </span>
            </div>
          )}

          <MultiSelect
            name="selectedColumnShow"
            options={detailState?.columnFilterData}
            className="pcp-multiselect common-new-multiselect w-200px"
            value={
              detailState?.columnFilterData?.filter(
                (val) => Array.isArray(detailState?.selectedColumnShow) && detailState?.selectedColumnShow.includes(val.value),
              ) || []
            }
            labelledBy={t('DEVLOPMENT_ORDER.PRODUCT_INFORMATIONS.PRODUCT_FILTER.SELECT_COLUMNS')}
            overrideStrings={{
              selectSomeItems: t('DEVLOPMENT_ORDER.PRODUCT_INFORMATIONS.PRODUCT_FILTER.SELECT_COLUMNS'),
            }}
            onChange={handleFilterSelect}
          />

          <MultiSelect
            name="pinnedColumns"
            options={
              detailState?.columnFilterData?.filter(
                (val) => Array.isArray(detailState?.selectedColumnShow) && detailState?.selectedColumnShow.includes(val.value),
              ) || []
            }
            className="pcp-multiselect common-new-multiselect w-200px ml-8"
            value={
              detailState?.columnFilterData?.filter(
                (opt) => Array.isArray(detailState?.selectedPinnedColumns) && detailState?.selectedPinnedColumns.includes(opt.value),
              ) || []
            }
            labelledBy={t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.PIN_COLUMNS') || 'Pin Columns (Max 5)'}
            overrideStrings={{
              selectSomeItems: t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.PIN_COLUMNS') || 'Pin Columns (Max 5)',
            }}
            onChange={handlePinnedColumnSelect}
            disabled={detailState?.loading || detailState?.tableLoading}
          />
        </div>
        <div className="search-filter ml-8 action-new-row cp-search">
          <div className="search-filter">
            <div ref={expandSearchRef} className="common-expand-search">
              <button type="button" onClick={handleIconClick} className="btn btn-toggle" aria-label={t('COMMON_LABEL.SEARCH')}>
                <span className="icon-Magnifying-Glass-Solid" />
              </button>
              <input
                type="text"
                value={detailState?.searchText}
                onChange={handleSearch}
                onKeyUp={(e) => submitSearch(e)}
                disabled={detailState.loading || detailState?.tableLoading || detailState?.isMainLoading}
                placeholder={t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.SEARCH_TASK')}
              />
            </div>
            <div className="action-icons-container">
              <PCPFilters applyFilter={applyFilter} filterState={filterState} setFilterState={setFilterState} setDetailState={setDetailState} />
              <CustomTooltip placement="top" tooltipText={t('APPROVE_REJECTS.BACK')}>
                <button onClick={redirectToListingPage} aria-label="Close" className="btn" type="button">
                  <span className="icon-close cursor-pointer  f-20" />
                </button>
              </CustomTooltip>
            </div>
          </div>
        </div>
        {!detailState?.tableLoading && (
          <div className="floting-actions">
            {!isEmpty(detailState.tabs) && !isProductArchived && (
              <>
                {!isSupplierLoggedIn && (
                  <CustomTooltip placement="top" tooltipText={t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.DOWNLOAD_PCP')}>
                    <button
                      type="button"
                      className="btn"
                      onClick={downloadOCPDetailsExcel}
                      aria-label="Download PCP"
                      disabled={detailState.loading || bulkUpdate}
                    >
                      <i className="icon-Download" />
                    </button>
                  </CustomTooltip>
                )}
                {!isSupplierLoggedIn && productAddEditAccess && individualDetail && (
                  <CustomTooltip placement="top" tooltipText={t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.UPLOAD_PCP')}>
                    <button type="button" className="btn" aria-label="Upload PCP" disabled={detailState.loading || bulkUpdate} onClick={handlePCPUpload}>
                      <i className="icon-Upload-1" />
                    </button>
                  </CustomTooltip>
                )}
                {(productAddEditAccess || (isSupplierLoggedIn && showSupplierRef.current)) && (
                  <CustomTooltip placement="top" tooltipText={t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.SAVE')}>
                    <button onClick={saveDetailPCP} aria-label="save" className="btn" type="button" disabled={detailState.loading || bulkUpdate}>
                      <i className="icon-Save-1" />
                    </button>
                  </CustomTooltip>
                )}
                {(productAddEditAccess || (isSupplierLoggedIn && showSupplierRef.current)) && (
                  <CustomTooltip placement="top" tooltipText={t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.BLK_UPDATE')}>
                    <button
                      aria-label={t('PRODUCT_CRITICAL_PATHS.DETAIL_PRODUCT_CP.BLK_UPDATE')}
                      className={`btn ${bulkUpdate ? 'active-update' : ''}`}
                      type="button"
                      disabled={detailState?.loading}
                      onClick={bulkUpdateClicked}
                    >
                      <i className="icon-Update-1" />
                    </button>
                  </CustomTooltip>
                )}
              </>
            )}
          </div>
        )}
      </div>
      <div className="bom-list">
        <Container fluid>{detailState?.isMainLoading ? <Loader /> : tableContainer()}</Container>
      </div>

      <ImportModal
        showUploadModal={showUploadModal}
        closeUploadModal={closeUploadModal}
        docRef={uploadDocRef}
        addDocument={handleUploadConfirm}
        loader={uploadLoader}
      />
    </>
  );
}

export default DetailProductCP;
